function PageNotFoundComponent({ contentData, initError, initLoader }) {

    return (
        <div id="not-found-container">
            <h1 className="error-title">404: Page Not Found</h1>
            <br/>
            <p>Oops! The page you are looking for does not exist.</p>
            <br/>
            <a href="/">Go Home</a>
        </div>
    );
}

export default PageNotFoundComponent;